import { render, staticRenderFns } from "./annonces.vue?vue&type=template&id=b8677f32&scoped=true&"
import script from "./annonces.vue?vue&type=script&lang=js&"
export * from "./annonces.vue?vue&type=script&lang=js&"
import style0 from "./annonces.vue?vue&type=style&index=0&id=b8677f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8677f32",
  null
  
)

export default component.exports